import nortMediumUrl from '@static/fonts/Nort-Medium.woff2?url';
import nortRegularUrl from '@static/fonts/Nort-Regular.woff2?url';
import robotoMonoMediumUrl from '@static/fonts/RobotoMono-Medium.woff2?url';
import robotoMonoRegularUrl from '@static/fonts/RobotoMono-Regular.woff2?url';
import { prepareChartNodeClone, renderChartNodeToHtml } from './copyChartDom';

const FONT_FACES = [
  { family: 'nort', weight: 400, url: nortRegularUrl },
  { family: 'nort', weight: 500, url: nortMediumUrl },
  { family: 'Roboto Mono', weight: 400, url: robotoMonoRegularUrl },
  { family: 'Roboto Mono', weight: 500, url: robotoMonoMediumUrl },
];

const CHART_SNAPSHOT_PADDING_PX = 10;

let embeddedFontCss: string | null = null;
let embeddedFontCssPromise: Promise<string> | null = null;

const fetchFontAsBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

export const prepareChartFonts = async (): Promise<string> => {
  if (embeddedFontCss !== null) {
    return embeddedFontCss;
  }

  if (!embeddedFontCssPromise) {
    embeddedFontCssPromise = Promise.all(
      FONT_FACES.map(async ({ family, weight, url }) => {
        const base64 = await fetchFontAsBase64(url);
        return `@font-face{font-family:"${family}";font-style:normal;font-weight:${weight};src:url(data:font/woff2;base64,${base64}) format("woff2");}`;
      })
    )
      .then(rules => {
        embeddedFontCss = rules.join('');
        return embeddedFontCss;
      })
      .catch(() => {
        embeddedFontCss = '';
        return '';
      });
  }

  return embeddedFontCssPromise;
};

export const renderAlfredChartNode = async (
  chartNode: HTMLDivElement
): Promise<string> => {
  const fontCss = await prepareChartFonts();

  const measureClone = prepareChartNodeClone(chartNode);
  const width = measureClone.offsetWidth;
  const height = measureClone.offsetHeight;
  document.body.removeChild(measureClone);

  return renderChartNodeToHtml(chartNode, {
    width,
    height,
    fontCss,
    trimPadding: CHART_SNAPSHOT_PADDING_PX,
    inlineSvgOptions: {
      expandViewBox: true,
      fontCss,
    },
  });
};
